export default __webpack_public_path__ + "static/media/mithai-baat-dijiye.78c94e13.jpg";